var SubtitleKinds = /* @__PURE__ */ ((SubtitleKinds2) => {
  SubtitleKinds2["CLOSED_CAPTION"] = "CLOSED_CAPTION";
  SubtitleKinds2["SUBTITLE"] = "SUBTITLE";
  return SubtitleKinds2;
})(SubtitleKinds || {});
var SubtitleType = /* @__PURE__ */ ((SubtitleType2) => {
  SubtitleType2["TTML"] = "TTML";
  SubtitleType2["WEBVTT"] = "WEBVTT";
  return SubtitleType2;
})(SubtitleType || {});
var MediaContainerType = /* @__PURE__ */ ((MediaContainerType2) => {
  MediaContainerType2["MP4"] = "MP4";
  MediaContainerType2["HLS_M3U8"] = "HLS_M3U8";
  MediaContainerType2["UNKNOWN"] = "UNKNOWN";
  MediaContainerType2["MPEG_PS"] = "MPEG_PS";
  MediaContainerType2["MPEG_TS"] = "MPEG_TS";
  MediaContainerType2["MXF"] = "MXF";
  MediaContainerType2["QTFF"] = "QTFF";
  MediaContainerType2["WEBM"] = "WEBM";
  MediaContainerType2["SMIL"] = "SMIL";
  return MediaContainerType2;
})(MediaContainerType || {});
var MediaStreamType = /* @__PURE__ */ ((MediaStreamType2) => {
  MediaStreamType2["UNKNOWN"] = "UNKNOWN";
  MediaStreamType2["HTTP"] = "HTTP";
  MediaStreamType2["HLS"] = "HLS";
  MediaStreamType2["DASH"] = "DASH";
  MediaStreamType2["MSS"] = "MSS";
  MediaStreamType2["RTSP"] = "RTSP";
  MediaStreamType2["RTP"] = "RTP";
  MediaStreamType2["PROGRESSIVE_HTTP"] = "PROGRESSIVE_HTTP";
  return MediaStreamType2;
})(MediaStreamType || {});
var MediaResolution = /* @__PURE__ */ ((MediaResolution2) => {
  MediaResolution2["UNKNOWN"] = "UNKNOWN";
  MediaResolution2["SD"] = "SD";
  MediaResolution2["ADAPTIVE"] = "ADAPTIVE";
  MediaResolution2["HD"] = "HD";
  MediaResolution2["UHD_4K"] = "UHD_4K";
  MediaResolution2["UHD_8K"] = "UHD_8K";
  return MediaResolution2;
})(MediaResolution || {});
var TrackType = /* @__PURE__ */ ((TrackType2) => {
  TrackType2["audio"] = "audio";
  TrackType2["text"] = "text";
  return TrackType2;
})(TrackType || {});
var PlayerEvent = /* @__PURE__ */ ((PlayerEvent2) => {
  PlayerEvent2["Play"] = "play";
  PlayerEvent2["Pause"] = "pause";
  PlayerEvent2["Seeked"] = "seeked";
  PlayerEvent2["Seeking"] = "seeking";
  PlayerEvent2["Waiting"] = "waiting";
  PlayerEvent2["Canplay"] = "canplay";
  PlayerEvent2["CanplayThrough"] = "canplaythrough";
  PlayerEvent2["Playing"] = "playing";
  PlayerEvent2["Progress"] = "progress";
  PlayerEvent2["TimeUpdate"] = "timeupdate";
  PlayerEvent2["Volumechange"] = "volumechange";
  PlayerEvent2["Ended"] = "ended";
  PlayerEvent2["Error"] = "error";
  PlayerEvent2["LoadedMetaData"] = "loadedmetadata";
  PlayerEvent2["LoadedData"] = "loadeddata";
  PlayerEvent2["MediaChange"] = "mediachange";
  PlayerEvent2["SetPlayer"] = "setplayer";
  PlayerEvent2["TimedMetaData"] = "timedmetadata";
  return PlayerEvent2;
})(PlayerEvent || {});
var TextTrackKind = /* @__PURE__ */ ((TextTrackKind2) => {
  TextTrackKind2["captions"] = "captions";
  TextTrackKind2["subtitle"] = "subtitle";
  return TextTrackKind2;
})(TextTrackKind || {});
var AudioTrackKind = /* @__PURE__ */ ((AudioTrackKind2) => {
  AudioTrackKind2["descriptive"] = "descriptive_audio";
  AudioTrackKind2["regular"] = "regular_audio";
  return AudioTrackKind2;
})(AudioTrackKind || {});
var SubtitleMime = /* @__PURE__ */ ((SubtitleMime2) => {
  SubtitleMime2["Vtt"] = "text/vtt";
  SubtitleMime2["Ttml"] = "application/ttml+xml";
  return SubtitleMime2;
})(SubtitleMime || {});
var DrmTypes = /* @__PURE__ */ ((DrmTypes2) => {
  DrmTypes2["FAIRPLAY"] = "FAIRPLAY";
  DrmTypes2["WIDEVINE"] = "WIDEVINE";
  DrmTypes2["PLAYREADY"] = "PLAYREADY";
  return DrmTypes2;
})(DrmTypes || {});
var MediaTypeExt = /* @__PURE__ */ ((MediaTypeExt2) => {
  MediaTypeExt2["Hls"] = ".m3u8";
  MediaTypeExt2["Dash"] = ".mpd";
  MediaTypeExt2["Mp4"] = ".mp4";
  return MediaTypeExt2;
})(MediaTypeExt || {});
var MediaMimeType = /* @__PURE__ */ ((MediaMimeType2) => {
  MediaMimeType2["Hls"] = "application/x-mpegURL";
  MediaMimeType2["Dash"] = "application/dash+xml";
  MediaMimeType2["Mp4"] = "video/mp4";
  return MediaMimeType2;
})(MediaMimeType || {});

export { AudioTrackKind, DrmTypes, MediaContainerType, MediaMimeType, MediaResolution, MediaStreamType, MediaTypeExt, PlayerEvent, SubtitleKinds, SubtitleMime, SubtitleType, TextTrackKind, TrackType };
